import { Col, Label, Row, Alert, ReactSelectBox, Tooltip, OutlineButton, PrimaryButton, SofturaTable, EventHandler } from "client/CommonComponents";
import './UserAccess.scss'
import { MultiSelect } from '@softura/customcomponent'
import TaskReset from '../../../../assets/images/TaskReset.svg'
import CompleteConfirmationPopup from "client/CommonComponents/DialogBox/CompleteConfirmationPopup";
import permissions, { isAuthorized } from "client/utils/Permissions";

const UserAccess = (props: any) => {
    const {
        rowData,
        userUpdated,
        costCenterSelectOnBlur,
        handleChangeSelectCostCenter,
        searchCostCenter,
        costCentersBySearchList,
        searchedUserCostCenter,
        gridData,
        gridColumn,
        fetchAction,
        pagesCount,
        paginationData,
        serverTotal,
        userCostCentersDropDownTemp,
        selectedUserCostCenter,
        onClickAdd,
        handleChangeSearchCostCenter,
        addUserCostCenterError,
        handleClickReset,
        onCancelCostCenterClick,
        dismissAlert,
        showAlert,
        popupContent,
        hideDialog
    } = props

    const getValues = (selectedUserCostCenter: any) => {
        let val = ""
        if (selectedUserCostCenter?.length) {
            selectedUserCostCenter?.map((item: any) => {
                if (val == '') {
                    val = item?.label
                } else {
                    val = val + ", " + item?.label
                }
            })
        }
        return val
    }

    return (
        <Row className="add-user-block">
            <Col xs={12} sm={12} md={4} lg={4} xl={4} className='mb-3'>
                <Label className="mb-1" data-attribute="UserAccess_Default_Label">User Name</Label>
                <p>{rowData?.fullName ?? '-'}</p>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={2} className='mb-3'>
                <Label className="mb-1" data-attribute="UserAccess_Default_Label_2">Emp#</Label>
                <p>{rowData?.employeeId ?? '-'}</p>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={6} className='mb-3'>
                <Label className="mb-1" data-attribute="UserAccess_Default_Label_3">Home Cost Center</Label>
                <p>{rowData?.homeCostcenter ?? '-'}</p>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <Label className="mb-1" data-attribute="UserAccess_Default_Label_4">Cost Center</Label>
                <Tooltip content={searchedUserCostCenter?.label ?? ""} data-attribute="UserAccess_Default_Tooltip">
                    <div className="cost-center_Reset">
                        <ReactSelectBox
                            name='searchedCostCenter'
                            placeholder='Search Cost Center'
                            options={costCentersBySearchList}
                            onChange={(value: any) => handleChangeSearchCostCenter(value)}
                            onInputChange={searchCostCenter}
                            value={searchedUserCostCenter}
                            isSearchable={true}
                            className=' cost-centerDD'
                            noOptionsMessage={() => "Not Available"}
                         data-attribute="UserAccess_searchedCostCenter_SearchSelectBox" />
                        
                            <EventHandler onEvent={(e: any) => handleClickReset(e)} data-attribute="UserAccess_Default_EventHandler">
                                <img src={TaskReset}
                                    className="ms-2 mt-0 mb-1 completed-reset"
                                />
                            </EventHandler>                          
                       
                    </div>
                </Tooltip>
                {addUserCostCenterError ? (
                    <span className="costCenter-validMessage">{addUserCostCenterError}</span>
                ) : null}
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={12} >
                <div className="AssetButtons pt-2 mb-sm-0 assetpopup_btn">
                    <div className="clearfix AssetButtonsRgt">
                        <OutlineButton
                            text='Cancel'
                            className='me-2 pull-left'
                            onClick={onCancelCostCenterClick}
                            disabled={searchedUserCostCenter?.length == 0 || searchedUserCostCenter == undefined}
                         data-attribute="UserAccess_Default_Button" />
                        <div className="search-button-alignment add_cancel_btn">
                            <PrimaryButton
                                text='Add'
                                onClick={(e: any) => { onClickAdd(e) }}
                                disabled={searchedUserCostCenter?.length == 0 || searchedUserCostCenter == undefined || !isAuthorized(permissions.Assign_Users)}
                             data-attribute="UserAccess_Default_Button_2" />
                        </div>
                    </div>
                </div>
            </Col>
            {showAlert?.showAddAlert ?
                <div className="vehicle-request-stepper mail-Alert vehicle_alert"><Alert
                    className="alert-message-stepper vehicle-success-alert"
                    showAlert={showAlert?.showAddAlert}
                    dismissAlert={dismissAlert}
                    type={showAlert?.type}
                    text={showAlert?.text}
                 data-attribute="UserAccess_Default_Alerts" /></div>
                : null}
            <Col xs={12} sm={12} md={12} lg={12} xl={12} className='mb-3'>
                <Tooltip content={selectedUserCostCenter ? getValues(selectedUserCostCenter) : ''} data-attribute="UserAccess_Default_Tooltip_2">
                    <MultiSelect
                        name='selectedCostCenter'
                        value={selectedUserCostCenter || []}
                        onChange={(value: any) => handleChangeSelectCostCenter(value)}
                        onBlur={costCenterSelectOnBlur}
                        options={userCostCentersDropDownTemp || []}
                        className='mb-2 cost-centerDD'
                        closeOnChangedValue={false}
                        isclearable={true}
                    />
                </Tooltip>
            </Col>
            <div className={`${gridData?.length != 0 ? "softura-table" : "softura-table paginationNav"}`}>
                <SofturaTable
                    data={gridData ?? []}
                    columns={gridColumn}
                    sort={true}
                    defaultPageSize={paginationData?.pageSize ?? 10}
                    pageSizes={[10, 20, 50]}
                    globalSearch={false}
                    filter={false}
                    serverTotal={serverTotal}
                    fetchAction={fetchAction}
                    isServerSide={true}
                    pagesCount={pagesCount}
                    defaultPaginationPosition='Both'
                    fixedHeader={true}
                 data-attribute="UserAccess_Default_Grid" />
            </div>
            {showAlert?.showSubmitAlert ?
                <div className="vehicle-request-stepper mail-Alert"><Alert
                    className="alert-message-stepper"
                    showAlert={showAlert?.showSubmitAlert}
                    dismissAlert={dismissAlert}
                    type={showAlert?.type}
                    text={showAlert?.text}
                 data-attribute="UserAccess_Default_Alerts_2" /></div>
                : null}
            <CompleteConfirmationPopup
                hideDialog={hideDialog}
                onDismiss={popupContent?.popupOutlinebtnOnclick}
                Popupcontent={popupContent}
                popupOutlinebtnOnclick={popupContent?.popupOutlinebtnOnclick}
                popupPrimarybtnOnclick={popupContent?.popupPrimarybtnOnclick}
            />
        </Row>
    )
}

export default UserAccess;
